import { useEffect, useMemo } from 'react';
import { clusterApiUrl } from '@solana/web3.js';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { WalletConnectWalletAdapter } from '@solana/wallet-adapter-walletconnect';
import '@solana/wallet-adapter-react-ui/styles.css';

function SolanaWalletProvider({ children }) {
    const endpoint = process.env.REACT_APP_SOLANA_RPC_URL || clusterApiUrl('mainnet-beta');
    const walletConnectProjectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;
    const hasWalletConnectProjectId = walletConnectProjectId
        && walletConnectProjectId !== 'seu_project_id'
        && walletConnectProjectId.length > 10;

    useEffect(() => {
        // Evita conexão automática com a última wallet detectada/salva.
        localStorage.removeItem('walletName');
        if (!hasWalletConnectProjectId) clearWalletConnectStorage();
    }, [hasWalletConnectProjectId]);

    function clearWalletConnectStorage() {
        Object.keys(localStorage)
            .filter(key => key.toLowerCase().includes('walletconnect') || key.toLowerCase().includes('wc@'))
            .forEach(key => localStorage.removeItem(key));
    }

    function onWalletError(error) {
        console.warn('Erro ao conectar carteira Solana:', error);
        localStorage.removeItem('walletName');
        clearWalletConnectStorage();
    }

    const wallets = useMemo(() => {
        const adapters = [
            new PhantomWalletAdapter(),
            new SolflareWalletAdapter()
        ];

        if (hasWalletConnectProjectId) {
            adapters.push(new WalletConnectWalletAdapter({
                network: 'mainnet-beta',
                options: {
                    relayUrl: 'wss://relay.walletconnect.com',
                    projectId: walletConnectProjectId,
                    metadata: {
                        name: 'Hydra Pool',
                        description: 'Integração Hydra com pools na Solana',
                        url: window.location.origin,
                        icons: [`${window.location.origin}/img/favicon/favicon-32x32.png`]
                    }
                }
            }));
        }

        return adapters;
    }, [walletConnectProjectId, hasWalletConnectProjectId]);

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect={false} onError={onWalletError}>
                <WalletModalProvider>
                    {children}
                </WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
}

export default SolanaWalletProvider;
